import { Box, Flex, Heading, Spacer, Image, Button, Text, HStack, VStack } from "@chakra-ui/react";
import { FaTags } from "react-icons/fa";
import { ColorModeButton } from "./ui/color-mode";
import { useColorModeValue } from "./ui/color-mode";
import logo from "../assets/logo.png";
import { useAuth } from "../context/AuthContext";
import { toaster } from "./ui/toaster";
import { useNavigate } from "react-router-dom";

export const Header = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      toaster.create({
        title: "Logged out",
        type: "info",
      });
      navigate("/login");
    } catch (error) {
      console.error("Logout error", error);
      toaster.create({
        title: "Logout failed",
        description: error.message,
        type: "error",
      });
    }
  };

  const bg = useColorModeValue("white", "gray.900");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const subTextColor = useColorModeValue("gray.600", "gray.400");
  const shadow = useColorModeValue("sm", "md");
  const profileBg = useColorModeValue("gray.50", "whiteAlpha.100");

  return (
    <Box
      as="header"
      width="100%"
      bg={bg}
      borderBottomWidth="1px"
      borderColor={borderColor}
      boxShadow={shadow}
      position="sticky"
      top="0"
      zIndex="1000"
      py={3}
      px={6}
    >
      <Flex align="center" justify="space-between">
        {/* Logo Section - Accessible Link */}
        <HStack
          as="a"
          href="/home"
          onClick={(e) => { e.preventDefault(); navigate("/home"); }}
          cursor="pointer"
          gap={3}
          _focus={{ boxShadow: "outline", borderRadius: "md" }}
          aria-label="Visionary Code Project Home"
        >
          <Image src={logo} alt="" boxSize="50px" objectFit="contain" aria-hidden="true" />
          <Heading size="lg" color={textColor} letterSpacing="tight">
            Visionary Code
          </Heading>
        </HStack>

        <Spacer />

        <HStack spacing={6}>
          <Button
            size="sm"
            variant="outline"
            colorScheme="purple"
            leftIcon={<FaTags />}
            onClick={() => navigate("/home", { state: { screen: 7 } })}
            aria-label="View plans and pricing"
            fontWeight="bold"
            borderRadius="full"
            px={4}
            display={{ base: "none", md: "flex" }}
          >
            Plans & Pricing
          </Button>
          {currentUser && (
            <HStack
              gap={4}
              p={2}
              borderRadius="full"
              bg={profileBg}
              borderWidth="1px"
              borderColor={borderColor}
            >
              <HStack gap={3}>
                <Box
                  w="10" h="10" borderRadius="full" bg="blue.600" color="white"
                  display="flex" alignItems="center" justifyContent="center"
                  fontWeight="bold" fontSize="lg"
                  borderWidth="2px" borderColor="white" shadow="sm"
                  aria-label={`Profile for ${currentUser.displayName || currentUser.email}`}
                  role="img"
                >
                  {(currentUser.displayName || currentUser.email || "U").charAt(0).toUpperCase()}
                </Box>
                <VStack align="start" gap={0} display={{ base: "none", md: "flex" }} mr={2}>
                  <Text fontWeight="bold" fontSize="md" color={textColor} lineHeight="short">
                    {currentUser.displayName || "User"}
                  </Text>
                  <Text fontSize="sm" color={subTextColor} lineHeight="short">
                    {currentUser.email}
                  </Text>
                </VStack>
              </HStack>

              <Button
                size="sm"
                colorScheme="red"
                variant="solid"
                onClick={handleLogout}
                aria-label="Log out of your account"
                fontWeight="bold"
                px={4}
              >
                Logout
              </Button>
            </HStack>
          )}
          <ColorModeButton aria-label="Toggle color mode" />
        </HStack>
      </Flex>
    </Box>
  );
};
